import {RootState} from '../rootReducer';

export const veevaSelector = (state: RootState) => state.veeva;
export const veevaVeapSelectorBuilder = (params: [string]) => (state: RootState) =>
  veevaSelector(state).veaps[params[0]];
export const veevaMdpSelectorBuilder = (params: [string]) => (state: RootState) => veevaSelector(state).mdps[params[0]];
export const veevaMdpModelLanguageSelectorBuilder = (params: [string, string[]]) => (state: RootState) =>
  veevaSelector(state).modelLanguages[params[0]];
export const veevaDocMetadataSelectorBuilder = (params: [string]) => (state: RootState) =>
  veevaSelector(state).docMetadatas[params[0]];
